import MomentFilter from 'filters/momentFilter';
import RangeFilter from 'filters/rangeFilter';
import ReverseRangeFilter from 'filters/reverseRangeFilter';
import TelFilter from 'filters/telFilter';
import UtcFilter from 'filters/utcFilter';
import CreditCardFilter from 'filters/creditCardFilter';
import AdmissionGroupTypeFilter from 'filters/admissionGroupTypeFilter';
import FormatMinFilter from 'filters/formatMinFilter';
import UppercaseIntialFilter from 'filters/uppercaseIntial';
import PercentageFilter from 'filters/percentage';
import VenueCurrencyFilter from 'filters/venueCurrency';

function init(app) {
  if (!app) throw new Error('app is required');

  app.filter('moment', MomentFilter);
  app.filter('range', RangeFilter);
  app.filter('reverserange', ReverseRangeFilter);
  app.filter('tel', TelFilter);
  app.filter('utc', UtcFilter);
  app.filter('creditcard', CreditCardFilter);
  app.filter('admissionGroupType', AdmissionGroupTypeFilter);
  app.filter('formatmin', FormatMinFilter);
  app.filter('uppercaseIntial', UppercaseIntialFilter);
  app.filter('percentage', PercentageFilter);
  app.filter('venueCurrency', VenueCurrencyFilter);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/filters/index.js